import _ from 'lodash'

export const signerOrder = function(signers) {
  let signersOnDocOrder = []

  if(signers && signers.length > 0){
    if(signers[0].firmarEnOrden){
      signersOnDocOrder = _.orderBy(signers, ['orden'], ['asc'])
    }else{
      _.forEach(signers, s => {
        s.nombreOrden = s.nombres.toLowerCase()
          .replace('á', 'a')
          .replace('é', 'e')
          .replace('í', 'i')
          .replace('ó', 'o')
          .replace('ú', 'u')
      })
      signersOnDocOrder = _.orderBy(signers, ['nombreOrden'], ['asc'])
    }
  }

  return signersOnDocOrder; 
}